export const bp1300 = 1300;
export const bp1100 = 1100;
export const bp1024 = 1024;
export const bp950 = 950;
export const bp860 = 860;
export const bp800 = 800;
export const bp720 = 720;
export const bp640 = 640;
export const bp620 = 620;
export const bp600 = 600;
export const bp490 = 490;
export const bp390 = 390;
